import { supabase } from '@/integrations/supabase/client';

/**
 * Admin data facade - parallel queries with aggressive caching
 * Following playbook pattern: thin UI, fat services
 */

export interface AdminStats {
  totalUsers: number;
  totalProducts: number;
  totalServices: number;
  totalMemberships: number;
  founderCount: number;
}

export async function getAdminStats(): Promise<AdminStats> {
  // Execute all stats queries in parallel
  const [usersRes, productsRes, servicesRes, membershipsRes, foundersRes] = await Promise.all([
    supabase.from('profiles').select('*', { count: 'exact', head: true }),
    supabase.from('products').select('*', { count: 'exact', head: true }),
    supabase.from('products').select('*', { count: 'exact', head: true }).eq('service_type', 'service'),
    supabase.from('memberships').select('*', { count: 'exact', head: true }),
    supabase.from('memberships').select('*', { count: 'exact', head: true }).eq('tier', 'founder'),
  ]);
  
  return {
    totalUsers: usersRes.count || 0,
    totalProducts: productsRes.count || 0,
    totalServices: servicesRes.count || 0,
    totalMemberships: membershipsRes.count || 0,
    founderCount: foundersRes.count || 0,
  };
}

export interface Category {
  slug: string;
  name: string;
}

export async function getCategories(): Promise<Category[]> {
  const { data, error } = await supabase
    .from('categories')
    .select('slug, name')
    .order('sort_order');
  
  if (error) throw error;
  return data || [];
}
